import { render, staticRenderFns } from "./ApprovalsValidationTable.vue?vue&type=template&id=0a6ced1a&scoped=true&"
import script from "./ApprovalsValidationTable.vue?vue&type=script&lang=js&"
export * from "./ApprovalsValidationTable.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalsValidationTable.vue?vue&type=style&index=0&id=0a6ced1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6ced1a",
  null
  
)

export default component.exports